import React, { useState } from 'react';
import { changePassword } from '../services/userService';

const EMPTY_FORM = { currentPassword: '', newPassword: '', confirmPassword: '' };

export default function ChangePasswordModal({ onClose }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [saving, setSaving] = useState(false);

  function handleChange(field, value) {
    setForm(f => ({ ...f, [field]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (form.newPassword.length < 6) {
      setError('La nueva contraseña debe tener al menos 6 caracteres.');
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError('Las contraseñas nuevas no coinciden.');
      return;
    }

    setSaving(true);
    try {
      await changePassword({
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.msg || 'No se pudo cambiar la contraseña.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 320,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="section-card"
        style={{ width: '100%', maxWidth: 440, marginBottom: 0, maxHeight: '90vh', overflowY: 'auto' }}
      >
        <div className="section-header">
          <h6>
            <i className="bi bi-key" style={{ color: 'var(--orig-green)' }} />
            Cambiar Contraseña
          </h6>
          <button
            type="button"
            onClick={onClose}
            style={{ background: 'none', border: 'none', color: 'var(--orig-text-muted)', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}
            title="Cerrar"
          >
            ×
          </button>
        </div>

        {success ? (
          <div className="section-body" style={{ textAlign: 'center', padding: '30px 20px' }}>
            <i className="bi bi-check-circle-fill" style={{ fontSize: 40, color: 'var(--orig-green)', display: 'block', marginBottom: 14 }} />
            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--orig-text)', marginBottom: 4 }}>
              Contraseña actualizada
            </div>
            <div style={{ fontSize: 12.5, color: 'var(--orig-text-muted)', marginBottom: 20 }}>
              Tu contraseña fue cambiada con éxito.
            </div>
            <button type="button" className="btn-orig btn-orig-green" onClick={onClose}>
              Cerrar
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="section-body">
              {error && (
                <div className="alert-orig alert-error" style={{ marginBottom: 16 }}>
                  <i className="bi bi-exclamation-triangle-fill" />
                  {error}
                </div>
              )}

              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label">Contraseña actual</label>
                  <input
                    type="password"
                    className="form-control"
                    value={form.currentPassword}
                    onChange={e => handleChange('currentPassword', e.target.value)}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Nueva contraseña</label>
                  <input
                    type="password"
                    className="form-control"
                    value={form.newPassword}
                    onChange={e => handleChange('newPassword', e.target.value)}
                    required
                    minLength={6}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Confirmar nueva contraseña</label>
                  <input
                    type="password"
                    className="form-control"
                    value={form.confirmPassword}
                    onChange={e => handleChange('confirmPassword', e.target.value)}
                    required
                    minLength={6}
                  />
                </div>
              </div>
            </div>

            <div style={{
              display: 'flex', justifyContent: 'flex-end', gap: 10,
              padding: '14px 20px', borderTop: '1px solid var(--orig-border)',
            }}>
              <button type="button" className="btn-orig btn-orig-outline" onClick={onClose}>
                Cancelar
              </button>
              <button type="submit" className="btn-orig btn-orig-green" disabled={saving}>
                <i className="bi bi-check-lg" />
                {saving ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
